module.exports = __webpack_public_path__ + "static/media/23_blanco.582854e5.svg";